import CalendarDrawer from "../../drawer/CalendarDrawer";
import MultiServiceAppointmentForm, {
  BookingMode,
  RowsUpdater,
  ServiceRow,
} from "./MultiServiceAppointmentForm";
import {
  GetTransactionsResponse,
  TransactionResponse,
} from "../../../../../types/transactions";
import type { CalendarEventType } from "../../../../../types/calendar";

interface SchedulingDrawerProps {
  opened: boolean;
  /** Every exit (close button, Cancel) routes through the discard gate. */
  onRequestClose: () => void;
  /** Drawer operating mode (create / edit / rebook) — also sets the title. */
  mode: BookingMode;
  sourceTransaction: GetTransactionsResponse | null;
  onEditSuccess: (splitTransactionIds: string[]) => void;
  /** The booking day ("YYYY-MM-DD"). */
  day: string;
  rows: ServiceRow[];
  onRowsChange: (update: RowsUpdater) => void;
  clientUuid: string;
  onClientChange: (clientUuid: string) => void;
  activeUid: number;
  onActiveChange: (activeUid: number) => void;
  onSuccess: (created: TransactionResponse[]) => void;
  /** Loaded calendar events (bottom overlap warning). */
  calendarEvents?: CalendarEventType[];
}

const titleForMode = (mode: BookingMode): string => {
  if (mode === "edit") return "Edit appointment";
  if (mode === "rebook") return "Prebook appointment";
  return "New appointment";
};

/**
 * Desktop scheduling surface: the booking form in the calendar drawer shell
 * (CalendarDrawer: right-side, non-modal, 400px, the grid reflows beside it).
 * Every exit routes through the discard gate. Mobile keeps its own surface;
 * walk-ins go through the waitlist drawer.
 */
export default function SchedulingDrawer({
  opened,
  onRequestClose,
  mode,
  sourceTransaction,
  onEditSuccess,
  day,
  rows,
  onRowsChange,
  clientUuid,
  onClientChange,
  activeUid,
  onActiveChange,
  onSuccess,
  calendarEvents,
}: SchedulingDrawerProps) {
  return (
    <CalendarDrawer
      opened={opened}
      onClose={onRequestClose}
      title={titleForMode(mode)}
    >
      <MultiServiceAppointmentForm
        mode={mode}
        sourceTransaction={sourceTransaction}
        onEditSuccess={onEditSuccess}
        initialDate={day}
        rows={rows}
        onRowsChange={onRowsChange}
        clientUuid={clientUuid}
        onClientChange={onClientChange}
        activeUid={activeUid}
        onActiveChange={onActiveChange}
        onCancel={onRequestClose}
        onSuccess={onSuccess}
        calendarEvents={calendarEvents}
      />
    </CalendarDrawer>
  );
}
